<template>
  <v-row>
    <v-col class="d-block pt-0" cols="12" v-if="displayedAlerts.length > 1">
      <v-alert
        type="warning"
        color="orange lighten-1"
        class="py-3 px-1 mb-0"
        role="note"
      >
        <template v-slot:prepend>
          <v-icon class="mx-2 d-none d-sm-block white--text">mdi-alert-circle-outline</v-icon>
        </template>
        <template>
          <div class="hidden-xs-only">
            <div class="d-flex justify-space-between align-center">
              You have multiple service notifications.
              <gg-btn color="orange" class="flex-shrink mr-2" :to="{ name: 'downtime' }" role="link">
                View Them
              </gg-btn>
            </div>
          </div>
          <div class="hidden-sm-and-up">
            You have multiple service notifications.
            <router-link :to="{ name: 'downtime' }" class="white--text fw-bold underline">View Them</router-link>.
          </div>
        </template>
      </v-alert>
    </v-col>
    <template v-else>
      <v-col v-for="alert in displayedAlerts"
             class="d-block pt-0"
             cols="12"
             :key="alert.id">
        <v-alert
          type="warning"
          color="orange lighten-1"
          class="py-3 px-1 mb-0"
          role="note"
        >
          <template v-slot:prepend>
            <v-icon class="mx-2 d-none d-sm-block white--text">mdi-alert-circle-outline</v-icon>
          </template>
          <template>
            <div class="hidden-xs-only">
              <div class="d-flex justify-space-between align-center">
                {{ alert.title }}
                <gg-btn color="orange" class="flex-shrink mr-2" :to="{ name: 'downtime-single', params: { id: alert.id } }" role="link">
                  View
                </gg-btn>
              </div>
            </div>
            <div class="hidden-sm-and-up">
              {{ alert.title }}. <router-link :to="{ name: 'downtime-single', params: { id: alert.id } }" class="white--text fw-bold underline">View</router-link>.
            </div>
          </template>
        </v-alert>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DownTimeAlerts',
  computed: {
    ...mapGetters({
      items: 'downtime/events'
    }),
    displayedAlerts () {
      return this.items.filter(i => i.banner === 1)
    }
  }
}
</script>
